import _ from 'lodash'
import { config } from '_/config/config'
import { router } from '_/router/router'
import { storage } from '_/services/storage'
import i18n from '_/i18n'
import { generateStatusIconHTML } from '_/helpers/iconHelper'

const photonConfig = require('~/config/config.json')

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    /**
     * An array of fields for the selected module
     */
    selectedModule: {
      required: true,
      type: Object,
    },
  },

  /**
   * Set the component data
   *
   * @type  {Object}
   */
  data: function() {
    return {
      // Select2 plugin initialization options
      options: {},
      placeholder: i18n.t('select2.typeToSearchForEntries'),
    }
  },

  /**
   * Set the computed properties
   *
   * @type  {Object}
   */
  computed: {
    /**
     * Sets the active state for the advanced search button
     *
     * @return  {boolean}
     */
    activeSearch() {
      return this.$route.params.moduleEntryId === 'search'
    },

    /**
     * Sets the disabled state for the search input
     *
     * @return  {boolean}
     */
    disabledSearch() {
      return (
        this.$route.params.moduleEntryId === 'search' ||
        this.selectedModule.type == 'single_entry'
      )
    },

    /**
     * Gets the module table name
     *
     * @return  {string}
     */
    relatedTableName() {
      return this.$route.params.moduleTableName
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Navigates to the search page
     *
     * @return  {void}
     */
    enterSearchMode: function() {
      if (this.selectedModule.type == 'single_entry') {
        return false
      }

      if (this.$route.params.moduleEntryId === 'search') {
        router.push(`/admin/${this.relatedTableName}`)

        return
      }

      router.push(`/admin/${this.relatedTableName}/search`)
    },

    /**
     * Initializes the Select2 plugin
     *
     * @return  {void}
     */
    initializeSelect2: function() {
      this.options = {
        allowClear: false,
        language: {
          noResults: function() {
            return $(`<li class="not-found">${i18n.t(
              'select2.noMatchesFound'
            )}</li>
                            <li class="launch-advanced-search">
                                <span class="link" onclick="$('#quicksearch').trigger('launchAdvancedSearch')">
                                    ${i18n.t('select2.useAdvancedSearch')}
                                </span>
                            </link>`)
          },
          inputTooShort: function() {
            return $(`<li>${i18n.t(
              'select2.pleaseEnterTwoOrMoreCharacters'
            )}</li>
                            <li class="launch-advanced-search">
                                <span class="link" onclick="$('#quicksearch').trigger('launchAdvancedSearch')">
                                    ${i18n.t('select2.useAdvancedSearch')}
                                </span>
                            </li>`)
          },
        },
        placeholder: this.placeholder,
        theme: 'bootstrap',
        escapeMarkup: function(markup) {
          return markup
        },
      }

      this.setAjaxOptions()

      this.initializeSelect2Plugin()
    },

    /**
     * Selects the DOM element and binds the Select2 plugin to it
     *
     * @return  {void}
     */
    initializeSelect2Plugin: function() {
      const $select2 = $(this.$el).find('select')

      $select2.select2(this.options)

      $select2.on('change', event => {
        if (parseInt(event.target.value) > 0) {
          router.push(`/admin/${this.relatedTableName}/${event.target.value}`)
          $select2.val(null).trigger('change')
        }
      })
      $select2.on('launchAdvancedSearch', () => {
        router.push(`/admin/${this.relatedTableName}/search`)
      })
    },

    setAjaxOptions: function() {
      const apiToken = storage.get('apiToken')
      const itemsPerPage = photonConfig.paginatedNodesItemsPerPage
      this.options.ajax = {
        cache: true,
        data: term => {
          let payload = {
            filter: {
              system: {
                anchor_text: {
                  like: term.term,
                },
              },
            },
            modules: [this.relatedTableName],
            pagination: {
              items_per_page: 10,
            },
          }

          return payload
        },
        dataType: 'json',
        delay: 250,
        headers: {
          Authorization: `Bearer ${apiToken}`,
        },
        processResults: function(data) {
          return {
            pagination: {
              more: data.body.pagination.has_more_pages,
            },
            results: data.body.entries.map(entry => {
              return { ...entry, id: entry.system.id }
            }),
          }
        },
        results: function(data) {
          return {
            more: true,
            results: data.body.entries.map(entry => {
              return { ...entry, id: entry.system.id }
            }),
          }
        },
        type: 'POST',
        url:
          config.ENV.apiBasePath +
          '/filter' +
          `?include[${this.relatedTableName}][system][]=id&include[${this.relatedTableName}][system][]=published_at&include[${this.relatedTableName}][system][]=anchor_text`,
      }

      this.options.minimumInputLength = 2

      const self = this

      this.options.templateResult = function(data) {
        if (_.get(data, 'system.anchor_text')) {
          return (
            generateStatusIconHTML(_.get(data, 'system.published_at')) +
            self.$options.filters.truncate(
              self.$options.filters.stripHtml(_.get(data, 'system.anchor_text'))
            )
          )
        }

        return data.text
      }

      this.options.templateSelection = function(data) {
        if (_.get(data, 'system.anchor_text')) {
          return (
            generateStatusIconHTML(_.get(data, 'system.published_at')) +
            self.$options.filters.truncate(
              self.$options.filters.stripHtml(_.get(data, 'system.anchor_text'))
            )
          )
        }

        return data.text
      }
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted: function() {
    this.$nextTick(function() {
      this.initializeSelect2()
    })
  },

  beforeDestroy: function() {
    const $select2 = $(this.$el).find('select')

    if ($($select2).data('select2')) {
      $select2.select2('destroy')
    }
  },

  /**
   * Set the watched properties
   *
   * @type  {Object}
   */
  watch: {
    $route(newEntry, oldEntry) {
      const moduleTableName = newEntry.params.moduleTableName

      const oldModuleTableName = oldEntry.params.moduleTableName

      // If module has changed
      if (moduleTableName !== oldModuleTableName) {
        const $select2 = $(this.$el).find('select')

        if ($($select2).data('select2')) {
          $select2.select2('destroy')
        }

        this.initializeSelect2()
      }
    },
  },
}
